import BasicSelect from "components/BasicInputs/BasicSelect";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import useCurrency from "helpers/useCurrency";
import { useAppSelector } from "../../store/store";

type Props = {
  jsonData: InstallmentData;
  installmentItem: {
    title: string;
    price: number;
    id: string;
  }[];
  id?: string;
  data: {
    payer_type: "factor" | "person";
    payer: {
      Person: {
        id: any;
      };
    };
    payer_id: number;
  };
  onChange?: (data: any) => void
};

const TransactionInstallmentForm = ({ jsonData, installmentItem, id, data, onChange }: Props) => {
  const store = useAppSelector((x: any) => x);
  const { shortCurrencies, defCur } = useCurrency();
  const installment = installmentItem.find((i) => i.id == id);
  return (
    <div className="min-w-[320px] bg-gray-100 p-8 flex flex-col gap-3 rounded-md">
      <div className="flex flex-col items-start mb-1">
        <span className="pb-2 mb-2 text-sm font-bold">{installment?.title}</span>
        <span className="text-xs text-gray-600">{jsonData.description}</span>
      </div>

      <BasicSelect
        label={"انتخاب شخص"}
        // name={"person"}
        options={store.personReducer.allPerson as Person[]}
        defaultValue={data.payer_type === "factor" ? data?.payer?.Person?.id : data.payer_id}
        refreshList={() => { }}
        onChange={(val, p: Person) => {
          // jsonData.setFieldValue("personId", val);
          // jsonData.setFieldValue("description", `اقساط برای ${p.nickName}`);
        }}
        withRefresh
        withSearch
        disabled
      />
      {/* <span>{data?.payer?.id}</span> */}
      {data.payer_type === "factor" && (
        <BasicSelect
          label={"فاکتور"}
          // name={"person"}
          options={store.factorReducer.factors as Factor[]}
          defaultValue={jsonData.factorId}
          refreshList={() => { }}
          onChange={(val, p: Person) => {
            // jsonData.setFieldValue("personId", val);
            // jsonData.setFieldValue("description", `اقساط برای ${p.nickName}`);
          }}
          withRefresh
          withSearch
          disabled
        />
      )}
      <BasicTextInput
        type="price"
        label="مبلغ پرداختی"
        style={{ padding: "0px 12px 0px 0px" }}
        val={installment?.price}
        onChange={(val) => {
          if (onChange) {
            onChange(val);
          }
        }}
        prefix={
          <div className="w-24 my-2 border-r border-gray-200">
            <BasicSelect
              disabled
              options={shortCurrencies}
              defaultValue={jsonData.currency?.value || defCur.value}
              onChange={(_, option) => { }}
              btnStyle={{
                border: "none",
                minWidth: 80,
              }}
              containerStyle={{ minWidth: 80 }}
              menuStyle={{ minWidth: 80 }}
            />
          </div>
        }
      />
    </div>
  );
};

export default TransactionInstallmentForm;
